import { useContext } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';
import AppContext from '../../AppContext';
import MyDropdownToggle from '../../shared/MyDropdownToggle';

export function AccountDropdownMenu({ logout }: { logout: () => void }) {
  const { user } = useContext(AppContext);

  if (!user) {
    return null;
  }

  return (
    <Dropdown>
      <MyDropdownToggle />
      <Dropdown.Menu>
        <Dropdown.Item as={Link} to="/about">
          About
        </Dropdown.Item>
        <Dropdown.Item as={Link} to="/donate">
          Donate
        </Dropdown.Item>
        <Dropdown.Item as={Link} to="/invitecodes">
          Invite Codes
        </Dropdown.Item>
        <Dropdown.Item as={Link} to="/premium">
          Premium
        </Dropdown.Item>
        <Dropdown.Item as={Link} to="/settings">
          Settings
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item as="button" onClick={logout}>
          Log Out
        </Dropdown.Item>
        {user.admin && (
          <>
            <Dropdown.Divider />
            <Dropdown.Header>Admin Section</Dropdown.Header>
            <Dropdown.Item as={Link} to="/admin">
              Admin
            </Dropdown.Item>
            {/* TODO: this is weak security measure until all pages are buttoned up for user state logged|premium|admin */}
            <Dropdown.Item as={Link} to="/sitemap">
              Sitemap
            </Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
